export enum AmplitudeEvent {
  ORDER_PAYMENT_FAILED = 'ORDER_PAYMENT_FAILED',
}

export const MAP_AMPLITUDE_EVENT_TO_NAME: Record<AmplitudeEvent, string> = { [AmplitudeEvent.ORDER_PAYMENT_FAILED]: 'Order Payment Failed' };
